import { render } from "./ContactSupportButton.vue?vue&type=template&id=02c0247a"
import script from "./ContactSupportButton.vue?vue&type=script&lang=js"
export * from "./ContactSupportButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__